/**
 * The four DOM helpers every feature needs. Deliberately four: this is not a
 * jQuery replacement, and anything more would grow into one.
 */

/** First match, or null. */
export const qs = (selector, root = document) => root.querySelector(selector);

/** All matches as a real Array, so .map/.filter/.forEach all work. */
export const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

/** Add a listener and get back a function that removes it. */
export function on(target, type, handler, options) {
  if (!target) return () => {};
  target.addEventListener(type, handler, options);
  return () => target.removeEventListener(type, handler, options);
}

/**
 * True when the visitor asked for less motion. Checked at call time rather than
 * cached, because the OS setting can change while the page is open.
 */
export const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;
